import React, { useState, useContext } from "react";
import { useNavigate } from 'react-router-dom'


import { enviar_reset } from '../../services/api';
import { Alert } from "react-bootstrap";

import { Navigate } from 'react-router-dom';
import './styles.css';

import imglogo from '../../img/logomarca.png'

import imgentrada from '../../img/teste.jpg'


const EnviaReset = () => {
  const navigate = useNavigate();

  const [email, setemail] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("submit", { email });
    try {
      const resultado = await enviar_reset(email);
      console.log("resultado reset", resultado);
      if (resultado.status === 200) {
        alert("Senha enviada para seu email cadastrado");
      } else if (resultado.status === 400) {
        alert("E-mail não possui perfil cadastrado");
      }
    } catch (error) {
      alert("Erro ao enviar senha. Tente novamente.");
      console.error("erro reset", error);
    }
    // alert("Senha enviada para seu email cadastrado");

    navigate("/login");

  };


  return (

    <div className="main">
      <div className="overlay"></div>


      <img src={imgentrada} autoPlay loop muted />

      <div className="content">
        <div className="login1" id="login">

          <form className="form-signin" onSubmit={handleSubmit}>

            <img className="logomarca" src={imglogo} autoPlay loop muted />

            <div className="form-floating">
              <label htmlFor="email" for="floatingInput" className="control-label" >E-Mail</label>
              <input type="email" className="form-control" name="email" id="email" placeholder="email" value={email} onChange={(e) => setemail(e.target.value)} />
            </div>
            <div className="actions">
              <button type="submit" className="btn btn-outline-primary btn-lg btn-banner" id="button">Enviar Senha</button>
            </div>

          </form>

        </div>
      </div>

    </div>
  );


}
export default EnviaReset;
